module.exports = __webpack_public_path__ + "img/3-1.43c1d572.svg";